module.exports = "/static/assets/b526b27033d326971504252c8a64799f.png";